import Box from '@mui/material/Box'

import type { Styles } from '../types/Styles'

export { CapoLogo }

const logo = '/images/capo-logo-liggend.svg'

type Props = {
  onClick?: () => void
  sx?: Styles
}

const defaultStyles: Styles = {
  maxHeight: 34,
}

const CapoLogo = ({ sx, onClick }: Props) => {
  return (
    <Box
      sx={{ ...defaultStyles, ...(onClick && { cursor: 'pointer' }), ...sx }}
      component="img"
      src={logo}
      alt="CAPO logo"
      onClick={onClick}
    />
  )
}
